import { render, staticRenderFns } from "./DeleteAccountConfirmationView.vue?vue&type=template&id=f800c24a&scoped=true&"
import script from "./DeleteAccountConfirmationView.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountConfirmationView.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountConfirmationView.vue?vue&type=style&index=0&id=f800c24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f800c24a",
  null
  
)

export default component.exports